import { assertDaysOfWeek, isValidLocalTime, localTimeToMinutes } from './local-time.js';
export function assertScheduleWindow(window) {
    assertLocalWindow(window.startLocalTime, window.endLocalTime, window.daysOfWeek, window.id);
}
export function assertScheduleRule(rule) {
    assertLocalWindow(rule.startLocalTime, rule.endLocalTime, rule.daysOfWeek, rule.id);
}
function assertLocalWindow(startLocalTime, endLocalTime, daysOfWeek, id) {
    if (!isValidLocalTime(startLocalTime) || !isValidLocalTime(endLocalTime)) {
        throw new Error(`Invalid schedule window times for ${id}`);
    }
    if (startLocalTime === endLocalTime) {
        throw new Error(`Schedule window ${id} must not have identical start and end times`);
    }
    assertDaysOfWeek(daysOfWeek);
}
/**
 * Whether a local wall-clock window is active at `clock`.
 *
 * Same-day windows are inclusive on both ends.
 * Overnight windows (e.g. 22:00–06:00) wrap midnight and stay inclusive.
 * Empty `daysOfWeek` means every day.
 */
export function isWindowActiveAt(window, clock) {
    if (window.daysOfWeek.length > 0 && !window.daysOfWeek.includes(clock.dayOfWeek)) {
        return false;
    }
    const start = localTimeToMinutes(window.startLocalTime);
    const end = localTimeToMinutes(window.endLocalTime);
    const now = clock.minutesOfDay;
    if (start < end) {
        return now >= start && now <= end;
    }
    // Overnight: active from start through midnight, and from midnight through end.
    return now >= start || now <= end;
}
//# sourceMappingURL=evaluate.js.map